import React from 'react';
import { first } from 'lodash';
import moment from 'moment';

import { nowAsTimestamp } from 'utils/date/now.util';

import NotificationAlert from 'notification/NotificationAlert';

const notificationByAfter =
  (cutoff) =>
  ({ delayTime, timestamp }) =>
    moment(timestamp + delayTime).isAfter(cutoff);

const compareBeforeWith =
  (cutoff) =>
  ({ delayTime: delayA, timestamp: stampA }, { delayTime: delayB, timestamp: stampB }) =>
    // TODO: check if cutoff is really necessary since A+B-C < D+E-C <=> A+B < D+E
    moment(stampA + delayA - cutoff).isBefore(stampB + delayB - cutoff) ? 1 : -1;

const rerenderNotifications = ({ notifications, cutoff, renderer }) => {
  const pendingNotifications = notifications.filter(notificationByAfter(cutoff));

  let rerenderInterval = null;
  if (pendingNotifications.length > 0) {
    const firstNotification = first(pendingNotifications.sort(compareBeforeWith(cutoff)));
    rerenderInterval = setInterval(renderer, firstNotification.timestamp + firstNotification.delayTime - cutoff);
  }
  return rerenderInterval;
};

const nextInteger = (value) => (Number.MAX_SAFE_INTEGER > value ? value + 1 : Number.MIN_SAFE_INTEGER + 1);

class NotificationContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      renderTrigger: 0,
      rerenderInterval: rerenderNotifications({
        notifications: props.listOfNotifications,
        cutoff: nowAsTimestamp(),
        renderer: this.triggerRender,
      }),
    };
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listOfNotifications !== this.props.listOfNotifications) {
      const newIntervalId = rerenderNotifications({
        notifications: nextProps.listOfNotifications,
        cutoff: nowAsTimestamp(),
        renderer: this.triggerRender,
      });

      const oldIntervalId = this.state.rerenderInterval;
      if (oldIntervalId) {
        clearInterval(oldIntervalId);
        this.setState({ rerenderInterval: newIntervalId, renderTrigger: nextInteger(this.state.renderTrigger) });
      } else {
        this.setState({ rerenderInterval: newIntervalId, renderTrigger: this.state.renderTrigger });
      }
    }
  }

  componentWillUnmount() {
    const { rerenderInterval } = this.state;
    if (rerenderInterval) {
      clearInterval(rerenderInterval);
    }
  }

  triggerRender = () => void this.setState({ renderTrigger: nextInteger(this.state.renderTrigger) });

  render() {
    const { closeNotification, listOfNotifications } = this.props;

    return (
      <div data-bem="NotificationContainer" className="notification-container">
        {Array.isArray(listOfNotifications) &&
          listOfNotifications
            .filter(({ delayTime, timestamp }) => nowAsTimestamp() > timestamp + delayTime)
            .filter(({ type }) => type !== 'info') // hide  alerts with  type 'info'
            .map(({ id, messageText, showCloseBtn, type }) => (
              <NotificationAlert id={id} key={id} messageText={messageText} type={type} showCloseBtn={showCloseBtn} closeNotification={closeNotification} />
            ))}
      </div>
    );
  }
}

export default NotificationContainer;
